// Phase 24B — New Call report (newly created outlets in date range)
import TransactionReportPage from "./TransactionReportPage";

export default function NewCallReport() {
  return (
    <TransactionReportPage
      slug="new-call"
      testidPrefix="new-call-report"
      title="New Call Report"
      subtitle="Outlets registered in the date range with first-order value & quantity."
      initialDaysBack={90}
      filterConfig={{ showUser: true, showDistributor: true }}
    />
  );
}
